import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  
  toggle(event) {
    const isChecked = event.target.checked
    
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
      checkbox.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
} 